module.exports = __webpack_public_path__ + "img/login-background.74fc4870.svg";